import P from '../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl'
import Redirector from '../routes/Redirector'
import FormHeader from './FormHeader';
import Circle from 'react-icons/lib/fa/circle';
import Check from 'react-icons/lib/fa/check-circle';
import Cross from 'react-icons/lib/fa/times-circle';

class Footer extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      page: this.props.page,
      content: this.props.content,
      pages: this.props.pages
    }
    this.tickOrCross = this.tickOrCross.bind(this);
  }
  tickOrCross(page, currentPage){
    const pages = this.props.pages;
    if (pages.indexOf(page) < pages.indexOf(currentPage)){
      return(
        <div>
          <Circle className="fa-stack-1x" style={{color: 'black'}}/>
          <Check className="fa-stack-1x"/>
        </div>
      )
    } else {
      return(
        <div>
          <Circle className="fa-stack-1x" style={{color: 'white'}}/>
        </div>
      )
    }
  }
  render() {
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const pages = this.props.pages;
    const currentPage = this.props.page;
    const displayFooter = pages.indexOf(currentPage) > -1

    if (currentPage != P.RETURN_LATER_PAGE){
      return (
        <div className='footer text-center'>
        {displayFooter && (<ul>
          {pages.map((page,i) => {
            if(page != P.RETURN_LATER_PAGE &&
               page != P.REGISTER_PAGE &&
               currentPage != P.RETURN_LATER_PAGE &&
               currentPage != P.REGISTER_PAGE){
              return (
                <li key={page+i} className={'footer-'+page}>
                  <span className="fa-stack">
                    {this.tickOrCross(page, currentPage)}
                  </span>
                </li>
              )
            }
          })}
          </ul>)}
        </div>
      )
    } else {
      return null
    }
  }
}

Footer.propTypes = {
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
}

const mapStateToProps = (state, props) => ({
  page: state.page,
  pages: state.pages,
  intl: props.intl,
  content: state.content
})

export default injectIntl(connect(mapStateToProps)(Footer))
